import { GoogleAuthError, LoginError, Maybe } from 'kb-shared';
import { History } from 'history';
import qs from 'qs';
import * as React from 'react';

import AuthFlowLayout from '../../components/AuthFlowLayout';
import { showErrorToast } from '../../utilities/notificationUtils';
import SignUpBox from './components/SignUpBox';
import ActivateBenefitBox from './components/ActivateBenefitBox';
import LoginFlow from './LoginFlow';

type Props = {
  history: History;
  location: Location;
};

type State = {
  targetRedirect: Maybe<string>;
};

export default class LoginScreen extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props);
    const params = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    const {
      target,
      membership_id: membershipId,
      enterprise_membership: enterpriseMembership
    } = params;
    // TODO: clean up this membership params stuff
    // the additional params from the target are being parsed as if they are their own params
    // they need to be considered one param, so we can redirect to a specific part of the booking flow
    // this is for the employer membership flow currently
    // side: also check ProtectedRoute where `location.pathname === '/book'`
    this.state = {
      targetRedirect:
        target &&
        `${target}${membershipId ? `&membership_id=${membershipId}` : ''}${
          enterpriseMembership ? `&enterprise_membership=${enterpriseMembership}` : ''
        }`
    };
  }

  redirectIfLoggedIn(isLoggedIn: boolean) {
    if (!isLoggedIn) return;

    // See if a target was passed into /login that we should redirect to after user logs in.
    const { targetRedirect } = this.state;
    if (targetRedirect) {
      this.props.history.push(targetRedirect);
      return;
    }
    this.props.history.push('/');
  }

  // @ts-ignore
  onGoogleAuthError = (googleAuthError?: GoogleAuthError, googleUserId: string) => {
    if (!googleUserId) return;
    if (!googleAuthError) return;
    // Coming from schedule consult if the user tries to sign up with
    // google and they already have an email account we redirect
    if (googleAuthError.type === 'UserAlreadyExistsAsEmail') {
      showErrorToast(
        'You already have an account using your email address and password. Please login'
      );
      return;
    }
    if (googleAuthError && googleAuthError.type !== 'UserHasNotSignedUp') return;
    this.props.history.replace(this.getCreateAccountPath());
  };

  getCreateAccountPath = () => {
    if (this.state.targetRedirect) {
      return `/create-account?step=create_account&target=${this.state.targetRedirect}`;
    } else {
      return 'create-account?step=create_account';
    }
  };

  render() {
    const isAMH = this.props.history.location.search.includes('event=amh');
    if (isAMH) {
      this.props.history.replace(`/amh-login${this.props.history.location.search}`);
    }

    return (
      <AuthFlowLayout
        title={'Log In'}
        renderMainContent={(mobile: boolean) => {
          return (
            <LoginFlow
              mobile={mobile}
              showSignUpBoxMobile={mobile}
              onLogin={() => {
                this.redirectIfLoggedIn(true);
              }}
              onError={(error: LoginError, email: string) => {
                if (error.type === 'Unconfirmed') {
                  setTimeout(() => {
                    this.props.history.replace('/verification-code', { email });
                  }, 3000);
                }
              }}
              onGoogleAuthError={this.onGoogleAuthError}
              onForgotPassword={() => {
                this.props.history.replace('/forgot-password');
              }}
              onSignUpPress={() => {
                this.props.history.replace(this.getCreateAccountPath());
              }}
            />
          );
        }}
        renderDesktopRightSidebar={() => {
          return (
            <>
              <SignUpBox
                mobile={false}
                onSignUpPress={() => {
                  this.props.history.push(this.getCreateAccountPath());
                }}
              />
              <ActivateBenefitBox
                mobile={false}
                onActivateBenefitPress={() => {
                  this.props.history.replace('/kindbody-benefit');
                }}
              />
            </>
          );
        }}
      />
    );
  }
}
